import { httpClient } from '@manager/api/http-client';
import type { IResponse } from '@manager/api/types/general-types';
import type { ISetupResponse } from '@manager/api/types/setup-types';
import { getApiBasePath } from '@manager/utils/request-utils';

export function getSetup(): Promise<IResponse<ISetupResponse>> {
  return httpClient.get(`${getApiBasePath()}/setup`);
}
